import { useReducer, useState } from 'react';

import { useContracts } from '../../../../hooks/queries/useContracts';
import { useCreateProperty } from '../../../../hooks/queries/useCreateProperty';
import { useValidateListing } from '../../../../hooks/queries/useValidateListing';
import { listingErrors as listingErrorsReducer, listing as listingReducer } from '../../AddPropertyModal/reducers';

import { EMPTY_ERROR, EMPTY_LISTING } from '../../AddPropertyModal/constants';

import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';

export const usePropertyFlow = (user?: RentalManagerAuthCheckUserInfoWebApiDto) => {
  const [listing, setListing] = useReducer(listingReducer, EMPTY_LISTING);
  const [listingErrors, setListingErrors] = useReducer(listingErrorsReducer, EMPTY_ERROR);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [unitNumberDetected, setUnitNumberDetected] = useState(false);
  const [isValidatedWithoutUnitDetected, setIsValidatedWithoutUnitDetected] = useState(false);
  const [propertyAlreadyPostedWarningMessage, setPropertyAlreadyPostedWarningMessage] = useState<
    string | Array<JSX.Element | string>
  >('');
  const [isRefocusingAddressInput, setIsRefocusingAddressInput] = useState(false);
  const [isImpreciseLocation, setIsImpreciseLocation] = useState(false);

  const contractsResponse = useContracts(setListing, setListingErrors, setIsSubmitDisabled, user);

  const { verifyCanSubmitForm, handleCheckLocationRestriction } = useValidateListing(
    listing,
    setListing,
    listingErrors,
    setListingErrors,
    setUnitNumberDetected,
    setIsValidatedWithoutUnitDetected,
    setPropertyAlreadyPostedWarningMessage,
    setIsImpreciseLocation,
    user,
    contractsResponse,
  );

  const { createProperty } = useCreateProperty();

  return {
    listing,
    setListing,
    listingErrors,
    setListingErrors,
    isSubmitDisabled,
    setIsSubmitDisabled,
    unitNumberDetected,
    setUnitNumberDetected,
    isValidatedWithoutUnitDetected,
    setIsValidatedWithoutUnitDetected,
    propertyAlreadyPostedWarningMessage,
    setPropertyAlreadyPostedWarningMessage,
    isRefocusingAddressInput,
    setIsRefocusingAddressInput,
    isImpreciseLocation,
    contractsResponse,
    verifyCanSubmitForm,
    handleCheckLocationRestriction,
    createProperty,
  };
};
